export const IP_REGEX = /^((25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(25[0-5]|2[0-4]\d|[01]?\d?\d)$/;

export const MAC_REGEX = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@_\-!~#&]).{8,}$/;

export const CIDR_REGEX =
  /^((25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(25[0-5]|2[0-4]\d|[01]?\d?\d)\/(3[0-2]|[12]?\d)$/;

const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const DIGITS = '0123456789';
const SPECIAL = '@_-!~#&';

const pickFrom = (chars: string): string => chars[Math.floor(Math.random() * chars.length)];

export const randomStrongPassword = (length = 12): string => {
  const required = [pickFrom(UPPER), pickFrom(LOWER), pickFrom(DIGITS), pickFrom(SPECIAL)];
  const pool = UPPER + LOWER + DIGITS + SPECIAL;
  const rest = Array.from({length: Math.max(0, length - required.length)}, () => pickFrom(pool));
  return [...required, ...rest].sort(() => Math.random() - 0.5).join('');
};

let counter = 0;
export const newLocalId = (prefix = 'local'): string => `${prefix}-${Date.now()}-${++counter}`;
